<div class="add-task-container">
    <div class="add-task-header">
        <h2 class="add-task-title">
            <i class="fas" [ngClass]="mode === 'edit' ? 'fa-edit' : 'fa-plus-circle'"></i>
            {{ mode === 'edit' ? 'Edit Task' : 'Create New Task' }}
        </h2>
    <span class="manual-label" *ngIf="mode !== 'view'">Manual</span>
    </div>

    <form class="add-task-form" [formGroup]="taskForm" (ngSubmit)="onSave()">
        <!-- Main Task Details -->
        <div class="form-section">
            <h3 class="section-title">Task Details</h3>

            <div class="form-row">
                <div class="form-group">
                    <label for="title" class="required">Title</label>
                    <input
                        type="text"
                        id="title"
                        class="form-control"
                        formControlName="title"
                        placeholder="Enter task title"
                        [class.is-invalid]="
                            taskForm.get('title')?.invalid &&
                            taskForm.get('title')?.touched
                        "
                    />
                    <div
                        class="invalid-feedback"
                        *ngIf="
                            taskForm.get('title')?.invalid &&
                            taskForm.get('title')?.touched
                        "
                    >
                        <small
                            *ngIf="taskForm.get('title')?.errors?.['required']"
                            >Title is required</small
                        >
                    </div>
                </div>

                <div class="form-group">
                    <label for="assignee" class="required">Assignee</label>
                    <select
                        id="assignee"
                        class="form-control"
                        formControlName="assignee"
                        [class.is-invalid]="
                            taskForm.get('assignee')?.invalid &&
                            taskForm.get('assignee')?.touched
                        "
                    >
                        <option [ngValue]="''">Select assignee</option>
                        <option *ngFor="let user of users" [ngValue]="user.id">
                            {{ user.name }}
                        </option>
                    </select>
                    <div
                        class="invalid-feedback"
                        *ngIf="
                            taskForm.get('assignee')?.invalid &&
                            taskForm.get('assignee')?.touched
                        "
                    >
                        <small
                            *ngIf="
                                taskForm.get('assignee')?.errors?.['required']
                            "
                            >Assignee is required</small
                        >
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label for="startDate" class="required">Start Date</label>
                    <input
                        type="datetime-local"
                        id="startDate"
                        class="form-control"
                        formControlName="startDate"
                        required
                        [class.is-invalid]="
                            taskForm.get('startDate')?.invalid &&
                            taskForm.get('startDate')?.touched
                        "
                    />
                    <div
                        class="invalid-feedback"
                        *ngIf="
                            taskForm.get('startDate')?.invalid &&
                            taskForm.get('startDate')?.touched
                        "
                    >
                        <small
                            *ngIf="
                                taskForm.get('startDate')?.errors?.['required']
                            "
                            >Start date is required</small
                        >
                    </div>
                </div>

                <div class="form-group">
                    <label for="dueDate" class="required">Due Date</label>
                    <input
                        type="datetime-local"
                        id="dueDate"
                        class="form-control"
                        formControlName="dueDate"
                        required
                        [class.is-invalid]="
                            taskForm.get('dueDate')?.invalid &&
                            taskForm.get('dueDate')?.touched
                        "
                    />
                    <div
                        class="invalid-feedback"
                        *ngIf="
                            taskForm.get('dueDate')?.invalid &&
                            taskForm.get('dueDate')?.touched
                        "
                    >
                        <small
                            *ngIf="
                                taskForm.get('dueDate')?.errors?.['required']
                            "
                            >Due date is required</small
                        >
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label for="category" class="required">Category</label>
                    <select
                        id="category"
                        class="form-control"
                        formControlName="category"
                        [class.is-invalid]="
                            taskForm.get('category')?.invalid &&
                            taskForm.get('category')?.touched
                        "
                    >
                        <option value="" selected disabled>
                            Select category
                        </option>
                        <option
                            *ngFor="let category of categories"
                            [value]="category.id"
                        >
                            {{ category.name }}
                        </option>
                    </select>
                    <div
                        class="invalid-feedback"
                        *ngIf="
                            taskForm.get('category')?.invalid &&
                            taskForm.get('category')?.touched
                        "
                    >
                        <small
                            *ngIf="
                                taskForm.get('category')?.errors?.['required']
                            "
                            >Category is required</small
                        >
                    </div>
                </div>

                <div class="form-group">
                    <label for="status">Status</label>
                    <select
                        id="status"
                        class="form-control"
                        formControlName="status"
                    >
                        <option
                            *ngFor="let status of statusOptions"
                            [value]="status.id"
                        >
                            {{ status.name }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="form-group" *ngIf="mode !== 'view'">
                <label for="attachments">Attach Photo/File</label>
                <input
                    type="file"
                    id="attachments"
                    class="form-control file-input"
                    (change)="onFileSelected($event)"
                    multiple
                    accept="image/*,.pdf,.doc,.docx"
                />
            </div>
        </div>

        <!-- Location Details -->
        <div class="form-section">
            <h3 class="section-title">Location Details</h3>

            <div class="form-row">
                <div class="form-group">
                    <label for="farm" class="required">Farm</label>
                    <select
                        id="farm"
                        class="form-control"
                        formControlName="farm"
                        (change)="onFarmSelected($event.target.value)"
                        [class.is-invalid]="
                            taskForm.get('farm')?.invalid &&
                            taskForm.get('farm')?.touched
                        "
                    >
                        <option value="">Select farm</option>
                        <option *ngFor="let farm of farms" [value]="farm.id">
                            {{ farm.name }}
                        </option>
                    </select>
                    <div
                        class="invalid-feedback"
                        *ngIf="
                            taskForm.get('farm')?.invalid &&
                            taskForm.get('farm')?.touched
                        "
                    >
                        <small
                            *ngIf="taskForm.get('farm')?.errors?.['required']"
                            >Farm is required</small
                        >
                    </div>
                </div>

                <div class="form-group">
                    <label for="house">House</label>
                    <select
                        id="house"
                        class="form-control"
                        formControlName="house"
                        (change)="onHouseSelected($event.target.value)"
                    >
                        <option value="">Select house</option>
                        <option *ngFor="let house of houses" [value]="house.id">
                            {{ house.name }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label for="partition">Partition</label>
                    <select
                        id="partition"
                        class="form-control"
                        formControlName="partition"
                        (change)="onPartitionSelected($event.target.value)"
                    >
                        <option value="">Select partition</option>
                        <option
                            *ngFor="let partition of partitions"
                            [value]="partition.id"
                        >
                            {{ partition.name }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="cycle">Cycle</label>
                    <select
                        id="cycle"
                        class="form-control"
                        formControlName="cycle"
                    >
                        <option value="">Select cycle</option>
                        <option *ngFor="let cycle of cycles" [value]="cycle.id">
                            {{ cycle.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <!-- Sub-tasks Section -->
        <div class="form-section">
            <div class="section-header">
                <h3 class="section-title">Sub-tasks</h3>
                <button type="button" class="btn-action" (click)="addSubTask()" *ngIf="mode !== 'view'">
                    <i class="fas fa-plus"></i> Add Sub-task
                </button>
            </div>

            <div *ngIf="subTasksFormArray.length === 0" class="no-subtasks">
                <p>
                    No sub-tasks added yet. Click "Add Sub-task" to create one.
                </p>
            </div>

            <div
                *ngFor="
                    let subTask of subTasksFormArray.controls;
                    let i = index
                "
                class="subtask-item"
                [formGroup]="subTask"
            >
                <div class="subtask-header">
                    <h4>Sub-task {{ i + 1 }}</h4>
                    <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        (click)="removeSubTask(i)"
                        *ngIf="mode !== 'view'"
                    >
                        <i class="fas fa-trash"></i>
                    </button>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label>Title</label>
                        <input
                            type="text"
                            class="form-control"
                            formControlName="title"
                            placeholder="Enter sub-task title"
                            [class.is-invalid]="
                                subTask.get('title')?.invalid &&
                                subTask.get('title')?.touched
                            "
                        />
                        <div
                            class="invalid-feedback"
                            *ngIf="
                                subTask.get('title')?.invalid &&
                                subTask.get('title')?.touched
                            "
                        >
                            <small
                                *ngIf="
                                    subTask.get('title')?.errors?.['required']
                                "
                                >Sub-task title is required</small
                            >
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Assignee</label>
                        <select
                            class="form-control"
                            formControlName="assignee"
                            [class.is-invalid]="
                                subTask.get('assignee')?.invalid &&
                                subTask.get('assignee')?.touched
                            "
                        >
                            <option [ngValue]="''" disabled>
                                Select assignee
                            </option>
                            <option
                                *ngFor="let user of users"
                                [ngValue]="user.id"
                            >
                                {{ user.name }}
                            </option>
                        </select>
                        <div
                            class="invalid-feedback"
                            *ngIf="
                                subTask.get('assignee')?.invalid &&
                                subTask.get('assignee')?.touched
                            "
                        >
                            <small
                                *ngIf="
                                    subTask.get('assignee')?.errors?.[
                                        'required'
                                    ]
                                "
                                >Sub-task assignee is required</small
                            >
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label>Start Date</label>
                        <input
                            type="datetime-local"
                            class="form-control"
                            formControlName="startDate"
                            [min]="minDate"
                            [class.is-invalid]="
                                subTask.get('startDate')?.invalid &&
                                subTask.get('startDate')?.touched
                            "
                        />
                        <div
                            class="invalid-feedback"
                            *ngIf="
                                subTask.get('startDate')?.invalid &&
                                subTask.get('startDate')?.touched
                            "
                        >
                            <small
                                *ngIf="
                                    subTask.get('startDate')?.errors?.[
                                        'required'
                                    ]
                                "
                                >Sub-task start date is required</small
                            >
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Due Date</label>
                        <input
                            type="datetime-local"
                            class="form-control"
                            formControlName="dueDate"
                            [min]="minDate"
                            [class.is-invalid]="
                                subTask.get('dueDate')?.invalid &&
                                subTask.get('dueDate')?.touched
                            "
                        />
                        <div
                            class="invalid-feedback"
                            *ngIf="
                                subTask.get('dueDate')?.invalid &&
                                subTask.get('dueDate')?.touched
                            "
                        >
                            <small
                                *ngIf="
                                    subTask.get('dueDate')?.errors?.['required']
                                "
                                >Sub-task due date is required</small
                            >
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label>Status</label>
                        <select class="form-control" formControlName="status">
                            <option
                                *ngFor="let status of statusOptions"
                                [ngValue]="status.id"
                            >
                                {{ status.name }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group" *ngIf="mode !== 'view'">
                        <label>Attach Photo/File</label>
                        <input
                            type="file"
                            class="form-control file-input"
                            (change)="onFileSelected($event, true, i)"
                            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="form-actions" *ngIf="mode !== 'view'; else viewFooter">
            <button
                type="button"
                class="close-btn-secondary"
                (click)="onClose()"
            >
                <i class="fas fa-times"></i>
                Cancel
            </button>
            <button
                type="submit"
                class="btn btn-action-primary"
                [disabled]="!isFormValid()"
            >
                {{ mode === 'edit' ? 'Save Changes' : 'Create Task' }}
            </button>
        </div>
        <ng-template #viewFooter>
            <div class="form-actions">
                <button
                    type="button"
                    class="close-btn-secondary"
                    (click)="onClose()"
                >
                    <i class="fas fa-times"></i>
                    Close
                </button>
            </div>
        </ng-template>
    </form>
</div>
